export default __webpack_public_path__ + "static/media/DZ.8e9f4d92.svg";